export const SectionHeader = ({ title, subtitle }) => (
  <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
    <h2 style={{ 
      fontSize: '2rem', 
      fontWeight: 700, 
      color: 'var(--text-primary)', 
      marginBottom: '0.5rem' 
    }}>
      {title}
    </h2>
    <p style={{ color: 'var(--text-secondary)', fontSize: '1.1rem' }}>
      {subtitle}
    </p>
  </div>
);
export default SectionHeader;